exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#wrapper {\n  width: 100%;\n  overflow-x: hidden;\n  background: #2f4050; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/taile-operate/BLACK-WIDOW/ng-src/app/module/index-operation/index/index.component.scss
// module id = ../../../../../ng-src/app/module/index-operation/index/index.component.scss
// module chunks = main